import { MembershipConstantS } from '../../../../../../services/MarppleShop/features/Membership/outbound/share.ts';

export const membership_menu_name = '멤버십/커미션/후원';
export const membership_pay_method_menu_name = '결제 수단';

/**
 * 개별 메뉴 아이템 구조
 * @typedef {Object} MenuItem
 * @property {string} title - 메뉴 표시명
 * @property {string} url - 메뉴 링크 경로 (/{언어코드}/@/... 형식)
 * @property {number} order - 메뉴 정렬 순서 (0부터 시작)
 * @property {boolean} [is_only_kr] - 국문만 표시되는 메뉴 여부 (optional)
 */

/**
 * 마이페이지의 전체 메뉴 구조를 반환하는 함수
 * @returns {Object} 마이페이지 메뉴 객체
 * @property {MenuItem} customer_orders - 주문 내역 메뉴
 * @property {MenuItem} membership - 멤버십 정보 메뉴 (한국 전용)
 * @property {MenuItem} reviews - 내가 작성한 리뷰 메뉴
 * @property {MenuItem} like - 좋아요 목록 메뉴
 * @property {MenuItem} my_recent - 최근 본 셀러 메뉴
 * @property {MenuItem} FAQ - FAQ 메뉴
 * @property {MenuItem} creator_question - 크리에이터 문의 내역 메뉴
 */
export const myPageMenus = () => ({
  customer_orders: { title: ET('ness::mypage::main_09'), url: `/${ET.lang}/@/orders`, order: 0 },
  membership: {
    title: membership_menu_name,
    url: `/${ET.lang}/@/${MembershipConstantS.my_memberships_path}`,
    order: 1,
    is_only_kr: true,
  },
  reviews: { title: T('My Writing'), url: `/${ET.lang}/@/my_review`, order: 3 },
  like: { title: ET('ness::mypage::main_11'), url: `/${ET.lang}/@/my_like`, order: 4 },
  my_recent: { title: ET('mps2::mypage::recent::title'), url: `/${ET.lang}/@/my_recent`, order: 5 },
  FAQ: { title: 'FAQ', url: `/${ET.lang}/@/help`, order: 6 },
  creator_question: {
    title: T('question::크리에이터 문의 내역 확인'),
    url: `/${ET.lang}/@/my_question`,
    order: 7,
  },
  // solution: { title: ET('ness::mypage::main_13'), url: `/${ET.lang}/@/solution`, order: 6 },
});

export const nessMyPageMenus = () => ({
  customer_orders: { title: ET('ness::mypage::main_09'), url: `/${ET.lang}/@/orders`, order: 0 },
  reviews: { title: ET('ness::mypage::main_10'), url: `/${ET.lang}/@/my_review`, order: 1 },
  like: { title: ET('ness::mypage::main_11'), url: `/${ET.lang}/@/my_like`, order: 2 },
  FAQ: { title: 'FAQ', url: `/${ET.lang}/@/help`, order: 3 },
  // questions: { title: ET('ness::mypage::main_12'), url: `/${ET.lang}/@/my_question`, order: 4 },
  // solution: { title: ET('ness::mypage::main_13'), url: `/${ET.lang}/@/solution`, order: 5 },
  // notice: { title: ET('ness::mypage::main_14'), url: `#`, order: 6 },
  // account: { title: ET('ness::mypage::main_07'), url: `/${ET.lang}/@/my_account`, order: 7 },
});

export const mypage_info_keys = {
  order_deliver_product_count: 'order_deliver_product_count',
  review_count: 'review_count',
  like_count: 'like_count',
};
